import { Paper, Stack, useTheme } from '@mui/material';
import { OrganizationPatientFilesContent } from 'src/sections/@dashboard/organization/components/OrganizationPatients/OrganizationPatient/OrganizationPatientFilesContent';

export default function OrganizationPatientTabsFilesPage() {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        borderRadius: 2,
        boxShadow: theme.customShadows.z8,
        height: 1,
        // Paper defaults to background.paper, which is the very colour the
        // table's header row uses — on that card the header vanished into it.
        // The lighter default surface gives the header something to sit
        // against, matching the visit's own cards.
        backgroundColor: 'background.default',
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px' }}>
        <OrganizationPatientFilesContent />
      </Stack>
    </Paper>
  );
}
